module.exports = __webpack_public_path__ + "img/016-pinned notes.736fff77.png";